<template>

    <div id="Integrations">

        <div class="flex">
            <div class="flex-1 mb-4">
                <h1 class="text-2xl font-medium text-gray-900 capitalize">Integrations</h1>
            </div>

            <CreateApiToken v-model="form" @createToken="createToken" :disabled="$parent.setupIncompleteBanner" v-if="loaded"></CreateApiToken>
        </div>

        <div class="flex flex-col" v-if="loaded">

            <div class="index-table" v-if="form.indexDataAvailable()">
                <div>
                    <div>
                        <table>
                            <thead>
                                <tr>
                                    <th scope="col" class="text-left tracking-wider">
                                        &nbsp;
                                    </th>
                                    <th scope="col" class="p-3 text-left tracking-wider">
                                        Name
                                    </th>
                                    <th scope="col" class="hidden lg:table-cell p-3 text-left tracking-wider text-right">
                                        Created
                                    </th>
                                    <th scope="col" class="relative p-3">
                                        <span class="sr-only">Delete Token</span>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="colored-row" v-for="(token, index) in form.index_data.data">
                                    <td>&nbsp;</td>
                                    <td class="whitespace-nowrap">
                                        <span class="font-medium text-gray-700">{{ token.name }}</span><br>
                                        <span class="text-xs text-gray-400">{{ token.id }} - {{ token.token_display }}</span>
                                    </td>
                                    <td class="hidden lg:table-cell text-right">
                                        {{ formatDate(token.created_at) }}<br>
                                        <span class="text-xs text-gray-400">Last used <span class="">{{ lastUsedAt(token.last_used_at) }}</span></span>
                                    </td>
                                    <td class="text-right">
                                        <div class="text-error-500 text-xs font-medium" v-if="token.deleted_at">
                                            Token Deleted<br>
                                            <span class="text-error-300">{{ formatDate(token.deleted_at) }}</span>
                                        </div>
                                        <ConfirmationModal button_classes="btn-error text-sm justify-center px-4 text-xs" button_text="Delete Token" @confirmModal="deleteToken(index)" v-else>
                                            <div class="mt-3 text-center sm:mt-5">
                                                <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-title">
                                                    Delete Token # {{ token.id }}?
                                                </h3>
                                                <p class="mt-2 text-sm text-gray-500">
                                                    Deleting this token will disable any integrations using this token (this action cannot be undone).
                                                </p>
                                                <div class="py-4 font-medium text-brand-700">
                                                    {{ token.token_display }}
                                                </div>
                                                <p class="text-gray-500">
                                                    This token was last used <span class="font-bold text-error-500">{{ lastUsedAt(token.last_used_at) }}</span>
                                                </p>
                                            </div>
                                        </ConfirmationModal>
                                    </td>
                                </tr>
                                <tr class="py-6 text-xs font-medium">
                                    <td colspan="4" class="text-center">
                                        <infinite-loading @infinite="infiniteHandler">
                                            <div slot="spinner">Loading...</div>
                                            <div slot="no-more">No more Integration Keys</div>
                                        </infinite-loading>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="panel" v-else>
                <div class="p-10">
                    <div class="text-gray-200 my-6">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-20 w-20 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 9l3 3-3 3m5 0h3M5 20h14a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                        </svg>
                    </div>

                    <h2 class="text-gray-600 font-medium text-2xl text-center">No Integrations Available</h2>

                    <p class="text-center mt-4 text-sm text-gray-500">
                        We could not find any integrations, create an API Token to begin.
                    </p>
                </div>
            </div>

        </div>
        <Loading message="Loading Integrations" v-else></Loading>

    </div>

</template>

<script>
import {Token} from "../../app/Auth/Token";
import Loading from "../Support/Loading";
import CreateApiToken from "./CreateApiToken";
import ConfirmationModal from "../Support/ConfirmationModal";
import InfiniteLoading from "vue-infinite-loading";
import {FormattingMixin, PermissionMixin} from "../../support/mixins";

export default {
    name: "Integrations",
    mixins: [PermissionMixin, FormattingMixin],
    data() {
        return {
            form: null,
            loaded: false,
        }
    },
    components: {
        Loading,
        CreateApiToken,
        ConfirmationModal,
        InfiniteLoading
    },
    methods: {
        lastUsedAt(value) {
            if (value) {
                return this.formatDate(value);
            }

            return 'Never';
        },
        createToken() {
            let vm = this;

            vm.form.create();
        },
        deleteToken(index) {
            let vm = this;
            let id = vm.form.index_data.data[index].id;

            vm.form.deleteToken(id).then(result => {
                vm.form.index_data.data[index] = result.data.data;

                vm.$forceUpdate();
            });
        },
        infiniteHandler($state) {
            let vm = this;

            vm.form.page += 1;

            if (vm.form.indexHasMoreResults()) {
                this.form.index(true).then(response => {
                    $state.loaded();
                });
            } else {
                $state.loaded();
                $state.complete();
            }
        },
    },
    mounted() {
        let vm = this;

        new Promise(resolve => {
            vm.form = new Token();

            vm.form.index().then(response => {
                resolve(true);
            }).catch(error => vm.handleError(error));

        }).then(result => {
            vm.loaded = result;
        });
    }
}
</script>


